module.exports = __webpack_public_path__ + "6a561d68369fd1fb9768cbc8641e5d95.eot";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Regular.eot
// module id = 341
// module chunks = 0